'use client';

import IconMessage from 'assets/icons/ic-message.svg';
import IconPig from 'assets/icons/ic-pig.svg';
import { getMainUrlOrganizer } from 'utils/misc';
import { PAGES_URL } from 'constants/index';
import LogoSympla from 'assets/icons/logoSympla';

import * as styles from './OrganizerBanner.css';
import { OrganizerButtons } from './OrganizerButtons';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';
import { analytics, analyticsEvents } from 'lib/analytics';

function OrganizerBanner() {
  const { ref, inView } = useInView();

  const defaultLinkHref = `${getMainUrlOrganizer()}${PAGES_URL.organizerCreateEvent}`;
  const outlineLinkHref = 'https://produtores.sympla.com.br/como-funciona/';

  useEffect(() => {
    if (!inView) return;
    analytics.sendEvent(analyticsEvents.sympla_for_producers_viewed);
  }, [inView]);

  return (
    <div className={styles.section} ref={ref}>
      <div className={styles.container}>
        <div className={styles.badgeContainer}>
          <div className={styles.badge}>
            <LogoSympla />
            <span>para Produtores</span>
          </div>
        </div>
        <div className={styles.wrapper}>
          <div>
            <h3 className={styles.title}>
              Crie eventos, divulgue e venda ingressos com facilidade
            </h3>
            <div className={styles.topicsContainer}>
              <div className={styles.topics}>
                <IconMessage />
                <span>
                  Da publicação à venda: <b>suporte em todas as etapas.</b>
                </span>
              </div>
              <div className={styles.topics}>
                <IconPig />
                <span>
                  Publicação grátis: <b>sem taxa de adesão ou mensalidade.</b>
                </span>
              </div>
            </div>
          </div>
          <div>
            <video
              className={styles.organizerExample}
              width={480}
              height={300}
              autoPlay
              loop
              muted
              playsInline
              poster="/discovery-assets/organizerPoster.webp"
            >
              <source
                src="/discovery-assets/organizerVideo.webm"
                type="video/webm"
              />
              <source
                src="/discovery-assets/organizerVideo.mp4"
                type="video/mp4"
              />
            </video>

            <OrganizerButtons
              defaultLinkHref={defaultLinkHref}
              outlineLinkHref={outlineLinkHref}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrganizerBanner;
